import React from "react";
import Product from "./Product";
import Pagination from "./Pagination";
import { formatNumber } from "../../../utils/utils";
import ProductCard from "./ProductCard";

const TopPagination = ({ pagination, onPageChange, currentPage }) => {
  return (
    <div className="top-pagination-container">
      <div className="top-pagination-results">
        <h5>{formatNumber(pagination.records)} resultados</h5>
      </div>
      <Pagination
        className="top-pagination-pagination"
        currentPage={currentPage}
        totalPages={pagination.total_pages}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default function ProductCatalog(props) {
  const {
    currencyLabel,
    products,
    header,
    pagination = {},
    currentPage,
    onPageChange,
  } = props;

  return (
    <div className="product-catalog">
      <div className="product-catalog-header-container">{header}</div>
      {/* { pagination.total_pages > 1  && */}
      <div className="product-catalog-top-pagination-container">
        <TopPagination
          pagination={pagination}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />
      </div>
      {/* } */}
      <div className="product-catalog-products-container">
        {products.map((p, i) => (
          <ProductCard 
            className="product-catalog-card"
            key={`p-id-${p.id}-${i}`}
            currencyLabel={currencyLabel}
            {...p}
          />
        ))}
      </div>
      {/* { pagination.total_pages > 1  && */}
      <div className="product-catalog-pagination-container">
        <Pagination
          totalPages={pagination.total_pages}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />
      </div>
      {/* } */}
    </div>
  );
}
